<div appModal [mainClass]="'lg-modal'" (closeModal)="close()">
  <section class="modal-title-container">
    <div class="modal--title">{{ title }}</div>
    <div class="modal--tabs">
      <button class="btn btn-lg btn-text" [class.text-charcoal]="viewAll" (click)="toggleShowAll($event, true)">
        All
      </button>
      <button class="btn btn-lg btn-text" [class.text-charcoal]="!viewAll" (click)="toggleShowAll($event, false)">
        Selected
      </button>
    </div>
  </section>

  <section class="modal-content-container">
    <cdk-virtual-scroll-viewport itemSize="50">
      <div class="section section-videos view-all filtering-modal-listing" *ngIf="visibleClips.length">
        <ng-container *cdkVirtualFor="let customVideo of visibleClips; let i = index; trackBy: trackByFn">
          <article
            videoCardV2
            [index]="i"
            [thumbnail]="{ source: customVideo?.urlThumb }"
            [videoDetails]="[
              {
                text: customVideo?.name || customVideo?.originalName
              },
              { text: customVideo?.eventName },
              { text: customVideo?.createdAt | date: 'MMMM d, yyyy':'UTC' }
            ]"
            [showToggleHideStatus]="true"
            [hideChecked]="
              customVideo?.metadata?.hideOnProfile === true ||
              (customVideo.metadata?.hideOnProfile !== true &&
                customVideo?.metadata?.hideOnProfile &&
                customVideo.metadata.hideOnProfile[this.user.id]) ||
              customVideo.hide ||
              false
            "
            (onToggleHide)="toggleHide($event, customVideo)"
            (onSelect)="playVideo(customVideo)"
          ></article>
        </ng-container>
      </div>
    </cdk-virtual-scroll-viewport>

    <!-- has no clips at all -->
    <div
      *ngIf="!visibleClips.length && !allClips.length"
      class="font-bold text-center my-50 no-content-placeholder flex flex-col justify-center items-center"
    >
      <img src="assets/images/svg/icons/misc/clips_placeholder_icon.svg" alt="Clips placeholder" />

      <p *ngIf="title === 'Clips'">No {{ title }} to show. Create a clip from any game - Give it a try!</p>
      <p *ngIf="title === 'Highlight Reels'">No highlight reels to show. Go to My Library to get a highlight reel</p>
      <p *ngIf="title === 'Games'">No games to show</p>

      <a class="btn btn-lg ml-10 mb-50" [routerLink]="['/my-library']" (click)="close()">Go to My Library</a>
    </div>
    <!-- has Clips, but none selected -->
    <div
      *ngIf="!visibleClips.length && allClips.length"
      class="font-bold text-center my-50 no-content-placeholder flex flex-col justify-center items-center"
    >
      <img src="assets/images/svg/icons/misc/clips_placeholder_icon.svg" alt="Clips placeholder" />

      <p>No {{ title | lowercase }} selected</p>
    </div>
  </section>

  <section *ngIf="visibleClips.length || (!visibleClips.length && allClips.length)" class="modal-actions-container">
    <button alt="Cancel" class="btn btn-lg btn-grey" [class.btn-disabled]="saveInProgress" (click)="close()">
      Cancel
    </button>
    <button alt="Submit" class="btn btn-lg" [class.btn-disabled]="saveInProgress || !formChanged" (click)="save()">
      Save
    </button>
  </section>
</div>
